import { render, staticRenderFns } from "./CoursewareStructuralElementSelector.vue?vue&type=template&id=092f94c4&"
import script from "./CoursewareStructuralElementSelector.vue?vue&type=script&lang=js&"
export * from "./CoursewareStructuralElementSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports